import React from 'react';
import ReportViewer from "./base/ReportViewer";

const RapportVentesDetaille = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"RapportVentesdetaillereport"} />
        </div>
    );
}
export default RapportVentesDetaille;